import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Box, Typography} from '@material-ui/core';
import {getTaggedBlogPosts} from '../../redux/thunks/getTaggedBlogPosts';
import BlogList from '../List/BlogList';

/**
 * This component fetches & shows (with pagination) the blogposts by a specific tag
 */
function TaggedBlogsContainer({tag}) {
  const dispatch = useDispatch();
  const blogIds = useSelector(state => state.tagBlog.byTag[tag]?.data);
  const blogs = useSelector(state => {
    if (blogIds?.length) {
      return blogIds.map(id => state.blog.byId[id]);
    }
    return null;
  });
  const isLoading = useSelector(state =>
    typeof state.tagBlog.byTag[tag]?.loading === 'boolean'
      ? state.tagBlog.byTag[tag]?.loading
      : true
  );
  const error = useSelector(state => state.tagBlog.byTag[tag]?.error);
  const hasNext = useSelector(state => state.tagBlog.byTag[tag]?.hasNext);

  const skeleton = !!(isLoading || error);
  const noData = !blogs?.length && !isLoading && !hasNext;
  const isLoadMoreDisabled = !!(!hasNext || error || isLoading);

  React.useEffect(() => {
    if (hasNext) {
      dispatch(getTaggedBlogPosts({tag}));
    }
  }, [tag, hasNext, dispatch]);

  return (
    <div>
      <Box my={4}>
        <Typography component="h1" variant="h4">
          {tag}
        </Typography>
      </Box>
      <BlogList
        blogs={blogs}
        noData={noData}
        skeleton={skeleton}
        buttonProps={{
          onClick: () => {
            dispatch(getTaggedBlogPosts({tag}));
          },
          disabled: isLoadMoreDisabled,
        }}
      />
    </div>
  );
}

TaggedBlogsContainer.propTypes = {
  /**
   * tag of blog posts
   */
  tag: PropTypes.string.isRequired,
};

export default TaggedBlogsContainer;
